import { INQUIRY_ERROR, GET_INQUIRY } from "../constants/inquiryConstants";

const initialState = {
  inquiries: null,
  loading: true,
};

export const requestInquiry = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_INQUIRY:
      return Object.assign({}, state, {
        inquiries: action.payload,
        loading: false,
      });
    case INQUIRY_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
